import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { logout } from '../features/auth/logoutSlice';
import { deletarTokenNoBack } from '../service/logout';
import { deletarSessao } from '../service/sessao';

const PrivateRoute = ({ children }) => {

  const dispatch = useDispatch();

  const tokenEmpresa = useSelector(state => state.token.tokenEmpresa);
  const token = localStorage.getItem('token');

  const isTokenExpired = (token) => {
    if (!token) return true;

    const decodedToken = jwtDecode(token);
    const expirationDate = new Date(decodedToken.exp * 1000);
    return expirationDate < new Date();
  };

  const isAuthenticated = () => {
    return token === tokenEmpresa && !isTokenExpired(token);
  };

  if (!isAuthenticated()) {
    limparInformacoes(dispatch);

    return <Navigate to="/login" replace />;
  };

  return children;
};

const limparInformacoes = async (dispatch) => {
  await deletarTokenNoBack();
  await deletarSessao();

  dispatch(logout());
  localStorage.clear();
  sessionStorage.clear();
};

export default PrivateRoute;
